
import global from '@/utils/global'
import { defineComponent } from 'vue'
import { getDispatchExamine, cancelDispatchExamine, getCompanyList } from '@/api/long-insure'
import { BillDetailDto, BillDto } from '@/api/bill'
import batchPayroll from '@/components/batch-payroll.vue'
import { insureDispatchList, insureDispatchDelete, addDispatch } from '@/api/insure-deduction'
import { ElMessage, ElMessageBox } from 'element-plus'
import staffBaseForm from '@/components/staff-base-form.vue'
import { insurePeriodReportCaseListApi, outDangerDetailApi } from '@/api/long-insure-new'
import { revokeReportCaseApi } from '@/api/insure-daily-ax'
import { formatter, filterIdCard, checkDeductionTaskTime } from '../utils/util'
import { reportStatusList, accidentTypeList, isUploadedList, flagList, superHurtTypeList } from '../utils/insure-daily-ax-dict'
import dayjs from 'dayjs'
import { outDangerDetailByIdApi } from '@/api/long-insure-new'

export default defineComponent({
  name: 'InsureDailyClaim',
  components: { staffBaseForm },
  data() {
    return {
      formatter,
      filterIdCard,
      reportStatusList,
      formSearch: {
        searchText: ''
      },
      pageSize: 10,
      pageNum: 1,
      total: 0,
      tableData: [],
      selects: [] as string[], // 列表选中
      showDrawer: false,
      staffBaseInfo: {} as any,
      userPlanInfo: {} as any,
      accidentTypeList,
      flagList,
      isUploadedList,
      superHurtTypeList,
      cardNumShow: false,
      staffColumnItem: [
        { label: '报案人', field: 'reportUserName', showType: 'normal' },
        { label: '报案时间', field: 'createTime', showType: 'normal' },
        { label: '出险人手机号', field: 'outDangerPhone', showType: 'normal' },
        { label: '报案人手机号', field: 'reportPhone', showType: 'normal' },
        { label: '事故类型', field: 'accidentType', showType: 'option' },
        { label: '是否住院', field: 'hospitalStatus', showType: 'option' },
        { label: '是否骨折', field: 'hurtStatus', showType: 'option' },
        { label: '出险地点', field: 'outDangerPlace', showType: 'normal' },
        { label: '就诊医院', field: 'visitHospital', showType: 'normal' },
        { label: '事故视频', field: '', showType: 'video' },
        { label: '报案材料', field: 'isUploaded', showType: 'option' },
        { label: '事故经过', field: 'accidentDetails', showType: 'normal' },
        { label: '出险人姓名', field: 'outDangerUserName', showType: 'normal' },
        { label: '身份证号', field: 'outDangerIdCardNo', showType: 'idCardNo' },
        { label: '商品名称', field: 'companyPlanName', showType: 'normal' },
        { label: '在保时间', field: '', showType: 'time' },
        { label: '派遣单位', field: 'serveCompanyName', showType: 'normal' },
        { label: '保障工种', field: 'occupationName', showType: 'childObj' }
      ],
      processList: [] as any
    }
  },
  created() {
    this.initTableList()
  },
  watch: {
    $route(to, from) {
      // 判断是否是从增加理赔页面返回
      if (from.path === '/long-insure-report-add' && to.path === '/insure-daily-claim') {
        this.initTableList() // 执行刷新方法
      }
    }
  },
  updated() {
    console.log('1111', this.$route.params)
  },
  methods: {
    async initTableList() {
      console.log(this.formSearch)
      const result = await insurePeriodReportCaseListApi({
        insureType: 8,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        searchText: this.formSearch.searchText
      })
      this.total = result.totalCount
      this.tableData = result.list
    },
    onSearch() {
      this.pageNum = 1
      this.initTableList()
    },
    onReset() {
      this.formSearch = {
        searchText: ''
      }
      this.onSearch()
    },
    handleSizeChange() {
      this.pageNum = 1
      this.initTableList()
    },

    // 添加
    async onCompanyAdd() {
      try {
        await checkDeductionTaskTime()
        this.$router.push({
          path: '/long-insure-report-add',
          query: {
            insureType: 8
          }
        })
      } catch (error) {
        // 时间限制，不执行跳转
        console.log('当前时间段不允许新增案件')
      }
    },
    // 点击出险人姓名
    async onClickName(row) {
      console.log('点击出险人姓名', row.name)
      // await
      this.showDrawer = true

      const result = await outDangerDetailByIdApi(row.reportNo as string)
      console.log(result, 'result')
      result?.reportCaseResultList?.forEach((item: { reportSolveResult: string; remark: string; createTime: string; desc: number; type: string; hollow: boolean }) => {
        this.processList.push({
          type: 'primary',
          hollow: true,
          reportSolveResult: item.reportSolveResult,
          timestamp: item.createTime,
          remark: item.remark,
          desc: item.desc
        })
      })
      this.staffBaseInfo = result
      this.staffBaseInfo['cardNumber'] = this.filterIdCard(result.outDangerIdCardNo)
      this.userPlanInfo = result.userPlanInfo
    },
    goBack() {
      this.showDrawer = false
    },
    // 撤销 案件
    async onBackOut() {
      console.log(this.staffBaseInfo.id, '撤销案件')
      await revokeReportCaseApi({ reportCaseId: this.staffBaseInfo.id })
      ElMessage.success('操作成功')
      this.goBack()
      this.initTableList()
    },
    onClickCardNo(val, field) {
      console.log(val, field, '点击身份 脱敏')
      this.cardNumShow = !this.cardNumShow
    },
    handleSelectionChange(selects: { id: string }[]) {
      this.selects = selects.map((item) => item.id)
    },
    // 检查在保结束时间，如果是2099-01-01则显示"结案断保"
    checkInsureEndTime(insureEndTime: string) {
      if (!insureEndTime) return '长期有效'
      // 使用 dayjs 判断日期是否为 2099-01-01
      const endDate = dayjs(insureEndTime).format('YYYY-MM-DD')
      return endDate === '2099-01-01' ? '结案断保' : insureEndTime
    }
  }
})
